// extracted by mini-css-extract-plugin
export default {"singleBars":"WorkspaceProgressCards_singleBars__1vsKs","date":"WorkspaceProgressCards_date__DpSFJ"};